"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAvererSignInRequired = void 0;
/** True when the account may no longer sign in with a Tokeniser password because it uses Averer. */
const isAvererSignInRequired = (result) => result?.payload?.signInMethod === "averer";
exports.isAvererSignInRequired = isAvererSignInRequired;
//# sourceMappingURL=IAuthService.js.map